<template>
  <div class="kontakt-container">
    <div class="kontakt-header">
      <h1>Kontakt</h1>
      <p>
        Ihr könnt mich mich per <a href=mailto:info@maikes-familienbegleitung.de>Mail</a> oder in dringenden Fällen auch telefonisch kontaktieren.
      </p>
    </div>
    <div class="kontakt-details">
      <div class="kontakt-info">
        <h2>Maikes Familienbegleitung</h2>
        <p>E-Mail: <a href=mailto:info@maikes-familienbegleitung.de>info@maikes-familienbegleitung.de</a></p>
        <p>Telefon: +49 1577 3577671</p>
        <p>56072 Koblenz-Metternich</p>
      </div>
      <!-- <div class="kontakt-formular"> -->
        <!-- <form @submit.prevent="submitForm"> -->
          <!-- <label for="name">Name*</label> -->
          <!-- <input type="text" id="name" v-model="formData.name" required />           -->
          <!-- <label for="email">E-Mail*</label> -->
          <!-- <input type="email" id="email" v-model="formData.email" required />           -->
          <!-- <label for="telefon">Telefonnummer*</label> -->
          <!-- <input type="tel" id="telefon" v-model="formData.telefonnummer" required />            -->
          <!-- <label for="beratungsthema">Beratungsthema*</label> -->
          <!-- <input type="text" id="beratungsthema" v-model="formData.beratungsthema" required />           -->
          <!-- <label for="nachricht">Nachricht*</label> -->
          <!-- <textarea id="nachricht" v-model="formData.nachricht" required></textarea>            -->
          <!-- <div class="checkbox-container"> -->
            <!-- <input type="checkbox" id="datenschutz" v-model="formData.datenschutz" required /> -->
            <!-- <label for="datenschutz">Ich habe die Datenschutzerklärung zur Kenntnis genommen und erkläre mich hiermit einverstanden.*</label> -->
          <!-- </div>           -->
          <!-- <button type="submit">Senden</button> -->
        <!-- </form> -->
      <!-- </div> -->
    </div>
    <!-- <div class="bild-placeholder">Bild-Platzhalter</div> -->
  </div>
</template>
 
<script>
  export default {
    name: 'Kontakt'
  }
</script>
<!-- <script> -->
<!-- export default { -->
  <!-- data() { -->
    <!-- return { -->
      <!-- formData: { -->
        <!-- name: '', -->
        <!-- email: '', -->
        <!-- telefonnummer: '', -->
        <!-- beratungsthema: '', -->
        <!-- nachricht: '', -->
        <!-- datenschutz: false, -->
      <!-- }, -->
    <!-- }; -->
  <!-- }, -->
  <!-- methods: { -->
    <!-- async submitForm() { -->
      <!-- try { -->
        <!-- const response = await fetch("https://sendemailcf-kdd73m7dtq-uc.a.run.app/", { -->
          <!-- method: "POST", -->
          <!-- headers: { -->
            <!-- "Content-Type": "application/json", -->
          <!-- }, -->
          <!-- body: JSON.stringify({ -->
            <!-- name: this.formData.name, -->
            <!-- email: this.formData.email, -->
            <!-- telephone: this.formData.telefonnummer, -->
            <!-- topic: this.formData.beratungsthema, -->
            <!-- message: this.formData.nachricht, -->
          <!-- }), -->
        <!-- }); -->
        
        <!-- if (response.ok) { -->
          <!-- alert('Formular erfolgreich gesendet!'); -->
        <!-- } else { -->
          <!-- alert("Fehler beim Senden des Formulars."); -->
        <!-- } -->
      <!-- } catch(error) { -->
        <!-- console.error("Error:", error); -->
        <!-- alert("Es gab einen Fehler beim Senden des Formulars."); -->
      <!-- } -->
      <!-- // Reset des Formulars -->
      <!-- this.formData = { -->
        <!-- name: '', -->
        <!-- email: '', -->
        <!-- telefonnummer: '', -->
        <!-- beratungsthema: '', -->
        <!-- nachricht: '', -->
        <!-- datenschutz: false, -->
      <!-- }; -->
    <!-- }, -->
  <!-- }, -->
<!-- }; -->
<!-- </script> -->

 
<style scoped>
.kontakt-container {
  padding: 1.25rem; /* 20px */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.kontakt-header {
  flex: 1;
  min-width: 300px;
  margin-right: 1.25rem; /* 20px */
  flex-direction: row;
}

.kontakt-details {
  flex: 1;
  min-width: 300px;
  margin-right: 1.25rem; /* 20px */
  flex-direction: row;
}
 
.kontakt-info {
  margin-bottom: 1.25rem; /* 20px */
}
 
.kontakt-formular {
  flex: 2;
  min-width: 300px;
}
 
.bild-placeholder {
  width: 100%;
  height: 400px;
  background-color: #ccc;
  margin-bottom: 1.25rem; /* 20px */
}
 
form {
  display: flex;
  flex-direction: column;
}
 
label {
  margin-top: 10px;
}
 
input, textarea {
  padding: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
 
.checkbox-container {
  display: flex;
  align-items: center;
}
 
button {
  margin-top: 1.25rem; /* 20px */
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
 
button:hover {
  background-color: #0056b3;
}
 
@media (max-width: 40rem) {
  .kontakt-inhalt {
    flex-direction: column;
  }
  .kontakt-details {
    margin-right: 0;
  }
}
</style>